import { createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e51720a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-wrapper" }
const _hoisted_2 = { class: "input-box-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal body-wrapper" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 임시비밀번호가 발송되었습니다."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 문자 또는 이메일을 확인해주세요 ")
  ])
], -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode($setup["Form"], {
      class: "form-wrapper",
      "validation-schema": $setup.schema
    }, {
      default: _withCtx(({ meta }) => [
        _createElementVNode("fieldset", _hoisted_1, [
          _createVNode($setup["TextInput"], {
            class: "input-box id",
            name: "id",
            placeholder: "사원번호 입력",
            label: "사원번호",
            value: $setup.userId,
            "onUpdate:value": [
              _cache[0] || (_cache[0] = ($event: any) => (($setup.userId) = $event)),
              $setup.resetErrorMessage
            ],
            "aria-required": true,
            "aria-describedby": 
            $setup.phoneNumberErrorMessage ? 'error-phone' : undefined
          
          }, null, 8 /* PROPS */, ["value", "aria-describedby"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode($setup["TextInput"], {
              ref: "phoneNumberInput",
              class: "input-box phone",
              name: "phone",
              type: "tel",
              label: "휴대폰번호",
              placeholder: "휴대폰번호 입력",
              maxlength: 13,
              value: $setup.phoneNumber,
              "onUpdate:value": [
                _cache[1] || (_cache[1] = ($event: any) => (($setup.phoneNumber) = $event)),
                _cache[2] || (_cache[2] = ($event: any) => ([$setup.resetErrorMessage(), $setup.onChangePhoneNumber()]))
              ],
              "aria-required": true,
              "aria-invalid": !!$setup.phoneNumberErrorMessage,
              "aria-describedby": 
              $setup.phoneNumberErrorMessage ? 'error-phone' : undefined
            
            }, null, 8 /* PROPS */, ["value", "aria-invalid", "aria-describedby"]),
            _withDirectives(_createElementVNode("p", {
              id: "error-phone",
              class: "error-message",
              role: "alert",
              "aria-live": "polite"
            }, _toDisplayString($setup.phoneNumberErrorMessage), 513 /* TEXT, NEED_PATCH */), [
              [_vShow, $setup.phoneNumberErrorMessage]
            ])
          ])
        ]),
        _createVNode($setup["BaseButton"], {
          class: "base-button",
          title: "비밀번호 찾기",
          disabled: !meta.valid,
          onOnClick: $setup.onSubmit
        }, null, 8 /* PROPS */, ["disabled"])
      ]),
      _: 1 /* STABLE */
    }),
    ($setup.findPasswordSuccess)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 0,
          title: "비밀번호 찾기",
          okButtonTitle: "로그인하기",
          onOnClickOkButton: $setup.goToLoginPage
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ]))
}